import type { NextPage } from 'next'
// import { useRouter } from 'next/router'
// import Link from 'next/link'
// import { useState } from 'react'

// import type { Item } from '@/modules/project'
import Dayjs from '@/components/dayjs'
import style from './item.module.css'

import AttachFileTable from './AttachFileTable'
import {OpinionDocument} from "@/modules/project";
import BlankPage from "@/components/pages/project/blank";

interface IProps {
  className?: string
  item?: OpinionDocument
}

const Component: NextPage<IProps> = ({ className , item}) => {
  const title = "주민의견수렴결과";
  return (
    <section className={className || ''}>
      <h3 className={style.h3}>
        {title}
      </h3>
      {
        item && item.idx?
            (
                <>
                  <div>
                    <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                      <colgroup>
                        <col width={200}/>
                        <col width={400}/>
                        <col width={200}/>
                        <col width={400}/>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th>게시기간</th>
                        <td><Dayjs format="dateDot">{item?.publicDisplayStartDatetime}</Dayjs> ~ <Dayjs format="dateDot">{item?.publicDisplayEndDatetime}</Dayjs></td>
                        <th>공지여부</th>
                        <td>{item?.isDisplay? "예": "아니오"}</td>
                      </tr>
                      <tr>
                        <th>내용</th>
                        <td colSpan={3}>
                          <div className='min-h-[120px] py-4 overflow-y-auto max-h-[600px] whitespace-pre-wrap'>
                            {item.contents || ''}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='my-8'>
                    <AttachFileTable title="주민의견수렴결과" items={item?.files? item.files: []}/>
                  </div>
                </>
            )
        :
        (
        <BlankPage title={title} className="mb-12" />
        )
      }

    </section>
  )
}

export default Component
